import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';
import techDocsPlugin from '@backstage/plugin-techdocs/alpha';
import { createApp } from '@backstage/frontend-defaults';
import { themeModule } from './modules/theme-module';
import { apiModule } from './modules/api-module';
import { signInModule } from './modules/sign-in-module';
import { navModule } from './modules/nav-module';
import { homeModule } from './modules/home-module';
import { storageModule } from './modules/storage-module';
import { announcementsModule } from './modules/announcements-module';
import { catalogEntityModule } from './modules/catalog-entity-module';
import { learnRedirectPlugin } from './plugins/learn-redirect-plugin';
import { customSearchModule } from './modules/search-module';
import { acceleratorPlugin } from './plugins/accelerator-plugin';

const app = createApp({
  features: [
    storageModule,
    homeModule,
    announcementsModule,
    themeModule,
    apiModule,
    signInModule,
    navModule,
    learnRedirectPlugin,
    customSearchModule,
    catalogPlugin,
    catalogGraphPlugin,
    orgPlugin,
    apiDocsPlugin,
    kubernetesPlugin,
    githubActionsPlugin,
    techDocsPlugin,
    catalogEntityModule,
    acceleratorPlugin,
  ],
});

export default app.createRoot();
